import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass } from '@angular/common';

import { StatusTileComponent } from './tile/tile.component'
import { ResponsiveComponent } from '@nx-superprep/shared'
import { _defaultCompletionState } from '../../@shared'
import { CompletionState } from './completion-state';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu'

@Component({
    selector: 'pop-ui-status',
    standalone: true,
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    imports: [NgClass, StatusTileComponent, TourMatMenuModule]
})
export class StatusComponent extends ResponsiveComponent {
  private _state: CompletionState = _defaultCompletionState
  @Input()
  get state() {
    return this._state
  }
  set state(value: CompletionState) {
    this._state = value
    this._today = { ...this._state, selected:'today'}
    this._overall = { ...this._state, selected:'overall'}
  }
  @Output() stateChange = new EventEmitter<CompletionState>()

  private _today: CompletionState = { ...this._state, selected:'today'}
  get today() { return this._today }

  private _overall: CompletionState = { ...this._state, selected:'overall'}
  get overall() { return this._overall }
}
